import {FormControl, FormGroup} from '@angular/forms';
import {BrokerSearchOutputItemModel, BrokerSearchOutputModel, OrderRouteService, ServerResponse} from '@spa/api';

import {OrderRoutesAssociationEnum} from '../../enums';
import {Subscription} from 'rxjs';
import {
    BrokerAssociationFormControls,
    BrokerAssociationFormControlsInterface, BrokerFormControlsCurrencySelector,
    BrokerFormControlsBrokerSelector
} from '../../../../../assets/descriptors';
import {RadioGroupControl, SelectControl} from '../../../../shared/classes';
import {ColorCodesEnum} from '../../../../shared/enums';

export class BrokerAssociationForm {
    private orderRouteService: OrderRouteService;
    private readonly objectId: number;
    private readonly associationType: OrderRoutesAssociationEnum;
    public availableBrokers: BrokerSearchOutputModel;
    public formGroup: FormGroup;
    public controls: BrokerAssociationFormControlsInterface;
    public subscriptions: Subscription[];
    public brokerFormControlsBrokerSelector: string;
    public brokerFormControlsCurrencySelector: string;
    private readonly currencyCodes: string[];
    private readonly selectedCurrencyCode: string;

    // tslint:disable-next-line:max-line-length
    constructor(
        orderRouteService: OrderRouteService,
        associationType: OrderRoutesAssociationEnum,
        objectId: number,
        availableBrokers: BrokerSearchOutputModel,
        currencyCodes: string[] = [],
        selectedCurrencyCode: string = null
    ) {
        this.objectId = objectId;
        this.associationType = associationType;
        this.availableBrokers = availableBrokers;
        this.orderRouteService = orderRouteService;
        this.subscriptions = [];
        this.brokerFormControlsBrokerSelector = BrokerFormControlsBrokerSelector;
        this.brokerFormControlsCurrencySelector = BrokerFormControlsCurrencySelector;
        this.currencyCodes = currencyCodes;
        this.selectedCurrencyCode = selectedCurrencyCode;

    }

    initForm(): void {
        this.formGroup = new FormGroup({});

        this.controls = BrokerAssociationFormControls(this.currencyCodes.length > 0);
        Object.keys(this.controls).forEach((formItemKey: string) => {
            const control = this.controls[formItemKey];
            if (control.name === this.brokerFormControlsCurrencySelector) {
                const formControl = control as SelectControl;
                formControl.options = this.currencyCodes.map((currencyCode: string) => {
                    return {
                        label: currencyCode,
                        value: currencyCode
                    };
                });
                control.value = this.selectedCurrencyCode;
            }
            if (control.name === this.brokerFormControlsBrokerSelector) {
                    const formControl = control as RadioGroupControl;
                    formControl.options = this.availableBrokers.content.map((broker: BrokerSearchOutputItemModel) => {
                        return {
                            label: broker.getName(),
                                value: broker.getId(),
                            color: ColorCodesEnum.Primary
                        };
                    });
                }
            this.formGroup.addControl(control.name, new FormControl(control.value, control.validators));
        });
    }

    createRequest(): ServerResponse<null> {
        if (!this.formGroup.dirty) {
            return null;
        }
        const value = this.formGroup.get(this.brokerFormControlsBrokerSelector).value;
        const currencyCode = this.controls.currency
            ? this.formGroup.get(this.brokerFormControlsCurrencySelector).value
            : null;

        switch (this.associationType){
            case OrderRoutesAssociationEnum.Account:
                return this.orderRouteService.addBrokerToAccount(value, this.objectId);
            case OrderRoutesAssociationEnum.AccountGroup:
                return this.orderRouteService.addBrokerToAccountGroup(value, this.objectId, currencyCode);
            case OrderRoutesAssociationEnum.TradingPlan:
                return this.orderRouteService.addBrokerToPlan(value, this.objectId);
        }
    }

    validateForm(messagesFunction: (controlsLabel?: string) => { [key: string]: string }): boolean {
        let isInvalidForm = false;

        if (this.formGroup.invalid) {
            Object.keys(this.controls).forEach((controlKey: string) => {
                const controlName = this.controls[controlKey].name;
                const formControl = this.formGroup.get(controlName);

                if (formControl && formControl.invalid) {
                    const errors = Object.keys(formControl.errors).map((errorKey: string) => {
                        return messagesFunction(this.controls[controlKey].placeholder)[errorKey];
                    });

                    this.controls[controlKey].setErrors(errors);
                }
            });

            isInvalidForm = true;
        }

        return !isInvalidForm;
    }
}
